import { SearchResultsPresentation } from "./SearchResultsPresentation";
import { Dispatch, SetStateAction } from "react";
import { useUserPreference } from "@coworker/app/src/hooks/useProfilePreferencesQuery";
import profilePreferences from "@coworker/enums/profilePreferences";
import { Item } from "../../../shared/types/item";
import { useSearchItems } from "@coworker/apprestructured/src/scan-and-search/hooks/search/useSearchItems";
import { useCallSikSearchBox as useCallSikSearchBoxCoworker } from "@coworker/apprestructured/src/scan-and-search/hooks/search/useCallSikSearchBoxCoworker";
import { SearchResultsSkeleton } from "@coworker/apprestructured/src/scan-and-search/components/searchResults/SearchResultsSkeleton/SearchResultsSkeleton";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";
import { checkSikSearchQueryForMultipleEntries } from "../../helpers/searchUtils";

interface SearchResultsProps {
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
  shouldHideSPRItems: boolean;
  shouldHideLocalCombinationItems: boolean;
  handleItemCardClick?: (item: Item) => void;
  itemCardRenderType?: SearchItemCardRenderType;
}

export const SearchResults = ({
  searchQuery,
  setSearchQuery,
  shouldHideSPRItems,
  shouldHideLocalCombinationItems,
  handleItemCardClick = () => {},
  itemCardRenderType = SearchItemCardRenderType.link,
}: SearchResultsProps) => {
  const shouldSkipSikSearch =
    checkSikSearchQueryForMultipleEntries(searchQuery);

  const {
    data: searchProposals,
    isLoading: isLoadingProposals,
    isError,
  } = useCallSikSearchBoxCoworker(searchQuery, shouldSkipSikSearch);

  const {
    data: items,
    isLoading,
    fetchNextPage,
    totalItems,
    isError: isErrorFetchingItems,
  } = useSearchItems(
    searchQuery,
    shouldHideSPRItems,
    shouldHideLocalCombinationItems,
    shouldSkipSikSearch
  );

  const [searchHistory, setSearchHistory] = useUserPreference<string[]>(
    profilePreferences.SEARCH_HISTORY,
    []
  );

  const isLoadingResults = isLoading || isLoadingProposals;
  const showSearchResultsPage =
    !isError && !isErrorFetchingItems && items && searchProposals;
  if (isLoadingResults) {
    return <SearchResultsSkeleton />;
  } else if (shouldSkipSikSearch || showSearchResultsPage) {
    return (
      <SearchResultsPresentation
        proposals={searchProposals ?? []}
        items={items}
        loading={isLoading || isLoadingProposals}
        totalCount={totalItems}
        searchQuery={searchQuery}
        handleLoadMoreClick={fetchNextPage}
        setSearchQuery={setSearchQuery}
        setSearchHistory={setSearchHistory}
        handleItemCardClick={handleItemCardClick}
        itemCardRenderType={itemCardRenderType}
        searchHistory={searchHistory}
        shouldShowNoResultsPage={shouldSkipSikSearch}
      />
    );
  } else {
    return null;
  }
};
